<template>
  <app-layout>
    <template #main-content>
      <main id="content" class="l-main p-learning">
        <div class="l-main__inner">
          <div class="c-subject-nav">
            <ul class="c-subject-nav__list">
              <li :key="0"
                :class="{'c-subject-nav__list__item':true,
                        'c-subject-nav__list__item--all':true,
                        'current': currentTab === '総合'}">
                <a href="javascript:void(0);" @click="selectTab('総合')" name="S5-2-subject-btn-総合">
                  <span class="label">総合</span>
                </a>
              </li>
              <template v-for="subject in globalNavigationStore.licensedSubject">
                <li v-for="sub_field in subject.subject_fields" :key="sub_field"
                    :class="{'c-subject-nav__list__item':true,
                            ['c-subject-nav__list__item--'+ subjectMap[subject.name]]:true,
                          'current': currentTab === sub_field}">
                  <a href="javascript:void(0);" @click="selectTab(sub_field)" :name="`S5-2-subject-btn-${sub_field}`">
                    <span class="label">{{sub_field}}</span>
                  </a>
                </li>
              </template>
            </ul>
          </div>
          <section>
            <mission-tab title="総合" name="all" :isAll="true" :key="0" :ref="(el) => {refTabs['総合'] = el}">
            </mission-tab>
            <template v-for="subject in globalNavigationStore.licensedSubject">
              <mission-tab
                v-for="sub_field in subject.subject_fields"
                :title="sub_field" :name="subjectMap[subject.name]" :key="sub_field" :ref="(el) => {refTabs[sub_field] = el}">
              </mission-tab>
            </template>
          </section>
        </div>
      </main>
    </template>
  </app-layout>
</template>

<script setup lang="ts">
  import {ref, onMounted, onUnmounted} from "vue";
  import {SUBJECT_MAP} from "@/consts/subject";
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useWorkStore } from '@/store/student/work_store';

  const subjectMap = SUBJECT_MAP
  const globalNavigationStore = useGlobalNavigationStore()
  const workStore = useWorkStore()
  const refTabs = ref([])
  const currentTab = ref('総合')
  onMounted(() => {
    document.title = "学習状況詳細（総合）- MANAVIRIA"
    globalNavigationStore.saveSelectedMenu('star')
    window.addEventListener('popstate', browserBackHandler);
    // show first tab content
    refTabs.value["総合"].isActive = true
    refTabs.value["総合"].isCalled = false
  })
  function browserBackHandler(){
    // make selectedWork empty avoid flicking work page
    workStore.saveSelectedWork([])
    window.location.reload()
  }
  async function selectTab(title: string){
    if(currentTab.value == title){
      return
    }
    // hide current tab content
    refTabs.value[currentTab.value].isActive = false
    // show selected tab content
    refTabs.value[title].isActive = true
    currentTab.value = title
    
    const tabItem = refTabs.value[title]
    if(tabItem.isAll==true){
      document.title = "学習状況詳細（総合）- MANAVIRIA"
    }else{
      document.title = "学習状況詳細（"+ tabItem.props.title + "）- MANAVIRIA"
      tabItem.firstTimeCallApi()
      tabItem.isCalled = false
    }
  }
  onUnmounted(() => {
    window.removeEventListener('popstate', browserBackHandler);
  })
</script>
